import sortArrayByKey from '~/assets/services/array/sort';

export default function (searchCriteriaParams) {
    return sortArrayByKey(searchCriteriaParams, 'asc', 'param').map(item => `${item.param}=${item.value}`).join('&');
}
